export default __webpack_public_path__ + "static/media/pranjal.42d5ba66.webp";